/* Project Import will be here */
import { getErrorObject, normalize } from "utilities/utils";
import { getAnyTokenFromState } from "services/index";
import {
  getCountriesApi,
  getStatesApi,
  getCitiesApi,
  getRegionsApi
} from "services/common";
import { IStatesParams, ICitiesParams, IRegionsParams, ILocationActionParams } from "models/commonModels";
/* Project Import will be here */

export const types = {
  LOAD_COUNTRIES_REQUEST: "location/LOAD_COUNTRIES_REQUEST",
  LOAD_COUNTRIES_SUCCESS: "location/LOAD_COUNTRIES_SUCCESS",
  LOAD_COUNTRIES_FAILURE: "location/LOAD_COUNTRIES_FAILURE",
  LOAD_REGIONS_REQUEST: "location/LOAD_REGIONS_REQUEST",
  LOAD_REGIONS_SUCCESS: "location/LOAD_REGIONS_SUCCESS",
  LOAD_REGIONS_FAILURE: "location/LOAD_REGIONS_FAILURE",
  LOAD_STATES_REQUEST: "location/LOAD_STATES_REQUEST",
  LOAD_STATES_SUCCESS: "location/LOAD_STATES_SUCCESS",
  LOAD_STATES_FAILURE: "location/LOAD_STATES_FAILURE",
  LOAD_CITIES_REQUEST: "location/LOAD_CITIES_REQUEST",
  LOAD_CITIES_SUCCESS: "location/LOAD_CITIES_SUCCESS",
  LOAD_CITIES_FAILURE: "location/LOAD_CITIES_FAILURE",
  ON_COUNTRY_CHANGE: "location/ON_COUNTRY_CHANGE",
  ON_REGION_CHANGE: "location/ON_REGION_CHANGE",
  ON_STATE_CHANGE: "location/ON_STATE_CHANGE",
  RESET_STATE: "location/RESET_STATE"
};

const initialState = {
  countries: {
    isLoading: false,
    ids: [],
    data: {},
    error: null
  },
  states: {
    isLoading: false,
    ids: [],
    data: {},
    error: null
  },
  regions: {
    isLoading: false,
    ids: [],
    data: {},
    error: null
  },
  cities: {
    isLoading: false,
    ids: [],
    data: {},
    error: null
  }
};

export const location = (state = initialState, action) => {
  switch (action.type) {

    /* Country section */
    case types.LOAD_COUNTRIES_REQUEST: {
      return { ...state, countries: { ...state.countries, isLoading: true } };
    }
    case types.LOAD_COUNTRIES_SUCCESS: {
      const { ids, data } = action.payload;
      return {
        ...state,
        countries: { ...state.countries, isLoading: false, ids, data }
      };
    }
    case types.LOAD_COUNTRIES_FAILURE: {
      const { error } = action.payload;
      return {
        ...state,
        countries: { ...state.countries, isLoading: false, error }
      };
    }

    /* Region section */
    case types.LOAD_REGIONS_REQUEST: {
      return { ...state, regions: { ...state.regions, isLoading: true } };
    }
    case types.LOAD_REGIONS_SUCCESS: {
      const { ids, data } = action.payload;
      return {
        ...state,
        regions: { ...state.regions, isLoading: false, ids, data }
      };
    }
    case types.LOAD_REGIONS_FAILURE: {
      const { error } = action.payload;
      return {
        ...state,
        regions: { ...state.regions, isLoading: false, error }
      };
    }

    /* State section */
    case types.LOAD_STATES_REQUEST: {
      return { ...state, states: { ...state.states, isLoading: true } };
    }
    case types.LOAD_STATES_SUCCESS: {
      const { ids, data } = action.payload;
      return {
        ...state,
        states: { ...state.states, isLoading: false, ids, data }
      };
    }
    case types.LOAD_STATES_FAILURE: {
      const { error } = action.payload;
      return {
        ...state,
        states: { ...state.states, isLoading: false, error }
      };
    }

    /* City section */
    case types.LOAD_CITIES_REQUEST: {
      return { ...state, cities: { ...state.cities, isLoading: true } };
    }
    case types.LOAD_CITIES_SUCCESS: {
      const { ids, data } = action.payload;
      return {
        ...state,
        cities: { ...state.cities, isLoading: false, ids, data }
      };
    }
    case types.LOAD_CITIES_FAILURE: {
      const { error } = action.payload;
      return {
        ...state,
        cities: { ...state.cities, isLoading: false, error }
      };
    }

    /* Change events section */
    case types.ON_COUNTRY_CHANGE: {
      return {
        ...state,
        regions: initialState.regions,
        states: initialState.states,
        cities: initialState.cities
      };
    }
    case types.ON_REGION_CHANGE: {
      return {
        ...state,
        states: initialState.states,
        cities: initialState.cities
      };
    }
    case types.ON_STATE_CHANGE: {
      return {
        ...state,
        cities: initialState.cities
      };
    }
    case types.RESET_STATE: {
      return initialState;
    }
    default:
      return state;
  }
};

/* Load the country list */
export const loadCountries = () => {
  return async (dispatch, getState) => {
    /* Reset the child dependencies like "Region, State and City" */
    dispatch({ type: types.ON_COUNTRY_CHANGE });

    dispatch({ type: types.LOAD_COUNTRIES_REQUEST });
    try {
      const params = { headers: getAnyTokenFromState(getState()) };

      /* getCountriesApi - Location level 0 */
      const response = await getCountriesApi(params);

      /* De-structure the country data */
      const { data, ids } = normalize({
        data: response.data.Data,
        key: "locid"
      });

      dispatch({ type: types.LOAD_COUNTRIES_SUCCESS, payload: { data, ids } });
    }
    catch (error) {
      const { message } = getErrorObject(error);
      dispatch({
        type: types.LOAD_COUNTRIES_FAILURE,
        payload: { error: message }
      });
    }
  };
};

/* Load the region list */
export const loadRegionsByCountry = (data: ILocationActionParams) => {
  return async (dispatch, getState) => {
    dispatch({ type: types.ON_REGION_CHANGE });
    dispatch({ type: types.LOAD_REGIONS_REQUEST });
    try {
      const params: IRegionsParams = {
        headers: getAnyTokenFromState(getState()),
        locId: data.locId
      };

      const response = await getRegionsApi(params);
      
      const dataArr = response.data.Data;
      const normalizedData = normalize({ data: dataArr, key: "locid" });
      dispatch({
        type: types.LOAD_REGIONS_SUCCESS,
        payload: { ...normalizedData }
      });
    } catch (error) {
      const { message } = getErrorObject(error);
      dispatch({
        type: types.LOAD_REGIONS_FAILURE,
        payload: { error: message }
      });
    }
  };
};

export const loadStatesByRegion = (data: ILocationActionParams) => {
  return async (dispatch, getState) => {
    dispatch({ type: types.ON_STATE_CHANGE });
    dispatch({ type: types.LOAD_STATES_REQUEST });
    try {
      const params: IStatesParams = {
        headers: getAnyTokenFromState(getState()),
        locId: data.locId
      };
      const response = await getStatesApi(params);
      const dataArr = response.data.Data;
      const normalizedData = normalize({ data: dataArr, key: "locid" });
      dispatch({
        type: types.LOAD_STATES_SUCCESS,
        payload: { ...normalizedData }
      });
    } catch (error) {
      const { message } = getErrorObject(error);
      dispatch({
        type: types.LOAD_STATES_FAILURE,
        payload: { error: message }
      });
    }
  };
};

export const loadCitiesByState = (data: ILocationActionParams) => {
  return async (dispatch, getState) => {
    dispatch({ type: types.LOAD_CITIES_REQUEST });
    try {
      const params: ICitiesParams = {
        headers: getAnyTokenFromState(getState()),
        locId: data.locId
      };
      const response = await getCitiesApi(params);
      const dataArr = response.data.Data;
      const normalizedData = normalize({ data: dataArr, key: "locid" });
      dispatch({
        type: types.LOAD_CITIES_SUCCESS,
        payload: { ...normalizedData }
      });
    } catch (error) {
      const { message } = getErrorObject(error);
      dispatch({
        type: types.LOAD_CITIES_FAILURE,
        payload: { error: message }
      });
    }
  };
};

export const resetState = () => {
  return dispatch => {
    dispatch({ type: types.RESET_STATE });
  };
};